import { render, staticRenderFns } from "./links-modal.vue?vue&type=template&id=2988e8fc&scoped=true"
import script from "./links-modal.vue?vue&type=script&lang=ts"
export * from "./links-modal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2988e8fc",
  null
  
)

export default component.exports